export const LOCALES = {
  en: 'en-GB',
  ru: 'ru-RU'
} as const;
